import { Snackbar } from "@material-ui/core";
import { Alert } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AlertActions } from "redux/actions";
import { RootReducer } from "redux/configurations/rootReducer";

export const GlobalAlert = () => {
  const dispatch = useDispatch();
  const alert = useSelector((state: RootReducer) => state.AlertReducer.alert);
  useEffect(() => {
    if (alert.show) {
      setTimeout(() => {
        dispatch(AlertActions.closeAlert.request());
      }, 3000);
    }
  }, [alert]);
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={alert.show}
    >
      <Alert variant="filled" severity={alert.type}>
        {alert.message}
      </Alert>
    </Snackbar>
  );
};
